import { cx } from "@jugl-web/utils";
import { FC, ReactNode } from "react";

interface WidgetContainerProps {
  children: ReactNode;
  className?: string;
}

export const WidgetContainer: FC<WidgetContainerProps> = ({
  children,
  className,
}) => (
  <div
    className={cx(
      "border-grey-300 min-h-0 w-full overflow-hidden rounded-xl border border-solid bg-white p-5",
      className
    )}
  >
    {children}
  </div>
);
